"use strict";

import 'babel-polyfill';
import React from "react";
import {render} from "react-dom";
import App from "../app/App.jsx";
import axios from "axios";
import {useQueries, useBasename} from "history";
import createHistory from 'history/lib/createBrowserHistory'

const history = useQueries(useBasename(createHistory))({
    basename: '/signup/'
});

module.exports = function renderApplication(props) {
    return render(<App {...props} fetch={props.fetch || axios} history={history}/>, document.getElementById('content'));
};


/** WEBPACK FOOTER **
 ** ./src/render/client.js
 **/